export default __webpack_public_path__ + "static/media/payment-icon.506b0b88.svg";